export const GermanData = [
  { 
    heading: "Bewertungswerkzeug-Pilot",
    atpSection: {
      introMessage: {
        quote: "Wir erwägen ein KI-Fahrzeugbewertungswerkzeug, um zu revolutionieren, wie wir Fahrzeuge bewerten. Ihre Teilnahme an diesem Pilotprojekt ist von unschätzbarem Wert, während wir die Technologie nutzen, um unsere Kunden besser zu bedienen.",
        author: {
          name: "Antonio Ward",
          designation: "General Manager – Fertigfahrzeuge",
          photo: '/Assets/images/photo.jpg',
        }
      },
      introVideoTitle: "Piloteneinführung"
    },
    purposeSection: {
      heading: "Zweck des Pilotprojekts",
      description: "Verwenden Sie die Apps von Focalx, um zu sehen, ob Sie leicht Gutachten erstellen können",
      taskHeading: "Ihre Aufgaben",
      tasks: [
        "Diese Landingpage als Lesezeichen speichern.", 
        "Scannen Sie den QR-Code unten, um die App „Auto Inspect“ herunterzuladen.", 
        "Melden Sie sich mit den Anmeldeinformationen an, die Ihnen von Ihrem Manager bereitgestellt wurden.", 
        "Machen Sie bei jeder Inspektion Fotos von allen Seiten des Autos.", 
        "Füllen Sie die VASCOR-Umfrage nach Erhalt jedes Berichts aus."
      ],
      timelineHeading : "Pilotenzeitplan",
    },
    inspectionSection: {
      heading: "Inspektions-Schulung: Wie führt man eine Inspektion mit der App durch?",
      downloadManual: "Handbuch herunterladen",
      relatedVideosTitle: "Schauen Sie sich unsere 30-Sekunden-Tutorials hier an.",
      relatedVideos: [
        {
          poster: '/Assets/images/user-flow-poster.png',
          video: "app-demo-walkthrough.mp4",
          title: "1. Benutzerfluss:",
          description: "Schneller Überblick von Anfang bis Ende des Benutzerflusses.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-01.png',
          video: "app-demo-walkthrough.mp4",
          title: "2. Herunterladen und Installieren:",
          description: "Verfügbar sowohl im App Store als auch bei Google Play, laden Sie die 'Auto Inspection' App herunter und starten Sie Ihre Inspektionen.",
          time: "0m24s"
        },
        {
          poster: '/Assets/images/Video-03.png',
          video: 'app-demo-walkthrough.mp4',
          title: "3. Inspektionen hinzufügen:",
          description: "Scannen Sie das Kennzeichen oder die Fahrgestellnummer, fügen Sie die Fahrzeugart hinzu und starten Sie Ihre neue Inspektion.",
          time: "0m16s"
        },
        {
          poster: '/Assets/images/Video-04.png',
          video: "app-demo-walkthrough.mp4",
          title: "4. KI-Führungssystem für Inspektionen:",
          description: "Erfassen Sie Ihr Fahrzeug mit Hilfe unseres KI-Führungssystems und lassen Sie Schäden in der App erkennen und dokumentieren.",
          time: "0m26s"
        },
        {
          poster: '/Assets/images/Video-02.png',
          video: "app-demo-walkthrough.mp4",
          title: "5. Inspektionen durchsuchen:",
          description: "Überblicken Sie Ihre Inspektionen, indem Sie durch die dokumentierten Schäden und Bilder Ihres Fahrzeugs blättern.",
          time: "0m30s"
        },
        {
          poster: '/Assets/images/Video-07.png',
          video: "app-demo-walkthrough.mp4",
          title: "6. PDF-Bericht herunterladen:",
          description: "Laden Sie den vollständigen Schadensbericht Ihres Fahrzeugs auf Ihr Telefon herunter, um schnell darauf zugreifen zu können.",
          time: "0m20s"
        },
        {
          poster: '/Assets/images/Video-05.png',
          video: "app-demo-walkthrough.mp4",
          title: "7. Schäden manuell hinzufügen:",
          description: "Fügen Sie weitere Schäden über die Funktion 'Schaden hinzufügen' hinzu.",
          time: "0m39s"
        },
        {
          poster: '/Assets/images/Video-08.png',
          video: "app-demo-walkthrough.mp4",
          title: "8. Anmelden und Ihre abgeschlossenen Inspektionen anzeigen:",
          description: "Erhalten Sie eine E-Mail mit allen Bildern Ihres Fahrzeugs und erkannten Schäden und melden Sie sich mit Ihren Anmeldedaten im Web-System an, um Ihre Inspektionen anzuzeigen.",
          time: "0m57s"
        },
        {
          poster: '/Assets/images/Video-09.png',
          video: "app-demo-walkthrough.mp4",
          title: "9. Wie sende ich eindeutige Links an den Kunden?",
          description: "Ein kurzer Überblick darüber, wie Sie Ihren Kunden einen Link senden können, damit diese eine Fahrzeuginspektion durchführen können.",
          time: "0m57s"
        }
      ]       
    },
    helpSection: {
      heading: "Wir sind rund um die Uhr für Sie da",
      chatHeading: "Chatten Sie mit uns",
      emailHeading: "Schreiben Sie uns eine E-Mail",
      chat: {
        intercom: "Intercom",
        whatsapp: "+502-570-3238",
        weChat: "WeChat",
        emailAddress: "contact@focalx.ai"
      },
      formHeading: "Hinterlassen Sie uns eine Nachricht und geben Sie Ihre E-Mail-Adresse an",       
      form: {
        nameFiled: "Enter name",
          emailField: "Enter email",
          commentField: "Enter message",
          buttonText: "Submit",
      }
    },
    faqSection: {
      heading: "FAQ'S",
      accordionItems: [
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: [
            "K1: Sie können dies wegwischen",
            "K2: Sie können dies polieren",
            "K3: Kleiner Schaden, den Sie nicht selbst reparieren können",
            "K4: Ein Fachmann muss dies reparieren",
            "K5: Das Teil muss möglicherweise ausgetauscht werden"
          ]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        },
        {
          accordianTitle: "Was bedeutet Quam adipiscing vitae proin sagittis rhoncus urna?",
          accordianContent: ["Aliquet enim tortor at auctor urna nunc id cursus metus. Nulla porttitor massa id neque aliquam vestibulum. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus ornare. Eu tincidunt tortor aliquam nulla facilisi cras fermentum odio eu."]
        }          
      ]
    },
    downloadSection: {
      content: {
        downloadNow: "Jetzt herunterladen",
        autoInspection: "Automatische Inspektion",
        description: "In der Hendrerit-Gravida-Rutrum, lass uns nicht erzählen, oder?",    
      }
    },
    footer: "© FocalX Ltd. Alle Rechte vorbehalten.",
    lockScreen: {
      title: "PIN eingeben, um Zugriff zu erhalten",
      buttonText: "Überprüfen"
    },
  }
];
  